export enum TakeOverScreenForDashboard {
    None = 0,
    AskAxxess = 8
}
